import { render } from "./SectionHeading.vue?vue&type=template&id=c7317d8a"
import script from "./SectionHeading.vue?vue&type=script&lang=js"
export * from "./SectionHeading.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/retail.digitalhq.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/admin/ui/Components/Common/SectionHeading.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c7317d8a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c7317d8a', __exports__)) {
    api.reload('c7317d8a', __exports__)
  }
  
  module.hot.accept("./SectionHeading.vue?vue&type=template&id=c7317d8a", () => {
    api.rerender('c7317d8a', render)
  })

}


export default __exports__